import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {getDictionary, getFallbackDictionary, getLanguage} from '../store/application.reducers';
import {translateWithPlaceholders} from './translations.wrapper';

export function useTranslation() {
    const dictionary = useSelector(getDictionary);
    const fallbackDictionary = useSelector(getFallbackDictionary);
    const language = useSelector(getLanguage);

    const translate = useCallback((key, ...args) => {
        return translateWithPlaceholders(key, dictionary, fallbackDictionary, ...args);
    }, [dictionary, fallbackDictionary, language]);

    const translationKeyExists = useCallback((key) => {
        return translate(key) !== key;
    }, [translate]);

    return {translate, translationKeyExists};
}

export default useTranslation;
